import React, { useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { Card, CardContent, Heading } from '@acorns/web-components'
import { useFeature } from '@acorns/web-toggles-react'
import { useAnalyticsClient } from '@acorns/web-utils'
import styled from 'styled-components'

import { style } from 'theme'
import { maintenanceScreenWeb } from 'utils/experiments/features'
import { MaintenanceScreenViewed } from 'utils/segment'
import { MAINTENANCE_CARD } from 'utils/testing/testIds'

type MaintenanceScreenVariables = {
  title?: string
  body?: string
}

export default () => {
  const [maintenanceScreenWebIsEnabled, variables] =
    useFeature<MaintenanceScreenVariables>(maintenanceScreenWeb)

  const analytics = useAnalyticsClient()
  const location = useLocation()

  if (!maintenanceScreenWebIsEnabled) {
    return <Redirect to="/" />
  }

  useEffect(() => {
    analytics.track('Screen Viewed', MaintenanceScreenViewed(location.pathname))
  }, [])

  const defaultTitle = 'Under Maintenance'
  const defaultBody =
    "We are currently performing our routine maintenance on our systems. Don't worry, your account is safe and we will be back shortly!"

  const title = (variables?.title as string) || defaultTitle
  const body = (variables?.body as string) || defaultBody

  const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${style((theme) => theme.colors.ivory)};
    width: 100%;
    height: 100%;
    padding: 20px;
  `

  const StyledCard = styled(Card)`
    max-width: 500px;
    min-height: 300px;
  `

  const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  `

  const Title = styled(Heading)`
    text-align: center;
    padding: 20px 0;
  `

  const Body = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: ${style((theme) => theme.colors.slate)};
    text-align: center;
    margin: 0;
  `

  return (
    <Container>
      <StyledCard data-testid={MAINTENANCE_CARD}>
        <StyledCardContent padding={'large'}>
          <AcornsIcon icon={AcornsIcon.Icon.AcornsLogo} width={38} />
          <Title>{title}</Title>
          <Body>{body}</Body>
        </StyledCardContent>
      </StyledCard>
    </Container>
  )
}
